import React, { createContext, useContext, useState, useEffect } from 'react';

interface AccountManagerContextType {
  viewAsUser: boolean;
  setViewAsUser: (value: boolean) => void;
  toggleViewAsUser: () => void;
}

const AccountManagerContext = createContext<AccountManagerContextType>({
  viewAsUser: false,
  setViewAsUser: () => {},
  toggleViewAsUser: () => {},
});

export function AccountManagerProvider({ children }: { children: React.ReactNode }) {
  // Persist view mode in localStorage
  const [viewAsUser, setViewAsUserState] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem('account-manager-view-as-user');
      return stored === 'true';
    } catch {
      return false;
    }
  });

  const setViewAsUser = (value: boolean) => {
    const previousValue = viewAsUser;
    setViewAsUserState(value);
    
    try {
      localStorage.setItem('account-manager-view-as-user', String(value));
    } catch {
      // Ignore localStorage errors
    }

    // Log mode changes for debugging
    if (previousValue !== value) {
      console.log(
        `Account Manager mode changed: ${value ? 'Viewing as User (restrictions ON)' : 'Account Manager mode (restrictions OFF)'}`
      );
    }
  };

  const toggleViewAsUser = () => {
    setViewAsUser(!viewAsUser);
  };

  return (
    <AccountManagerContext.Provider value={{ viewAsUser, setViewAsUser, toggleViewAsUser }}>
      {children}
    </AccountManagerContext.Provider>
  );
}

export function useAccountManagerMode() {
  return useContext(AccountManagerContext);
}

